const translations = {
  fr: {
    // Notifications
    welcome_title: "Bienvenue",
    config_title: "Configuration",
    config_description: "Configurez vos paramètres pour une expérience optimale.",
    whatsapp_title: "Rejoignez notre communauté",
    whatsapp_description: "Rejoignez notre groupe WhatsApp pour échanger avec d'autres utilisateurs et obtenir de l'aide.",
    join_button: "Rejoindre",
    welcome_description: "Nous sommes ravis de vous accueillir dans votre ERP.",
    // Common UI
    dashboard: "Tableau de bord",
    overview: "Vue d'ensemble",
    products: "Produits",
    ventes: "Ventes",
    sales: "Ventes",
    achats: "Achats",
    clients: "Clients",
    fournisseurs: "Fournisseurs",
    depenses: "Dépenses",
    members: "Membres",
    add_member: "Ajouter un membre",
    edit_member: "Modifier le membre",
    member_details: "Détails du membre",
    preview: "Aperçu",
    name: "Nom",
    role: "Rôle",
    phone: "Téléphone",
    salary: "Salaire",
    cin: "CIN",
    close: "Fermer",
    search_member_placeholder: "Rechercher par nom, rôle ou téléphone...",
    loading: "Chargement...",
    export_members_title: "Exporter les membres",
    export_excel: "Exporter Excel",
    export_pdf: "Exporter PDF",
    confirm_delete: "Confirmer la suppression",
    delete_member_confirm: "Êtes-vous sûr de vouloir supprimer le membre",
    delete_warning: "Cette action ne peut pas être annulée.",
    settings: "Paramètres",
    logout: "Déconnexion",
    notifications: "Notifications",
    add: "Ajouter",
    addNewProduct: "Ajouter un nouveau produit",
    edit: "Modifier",
    delete: "Supprimer",
    search: "Rechercher...",
    export: "Exporter",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    yes: "Oui",
    no: "Non",
    actions: "Actions",
    no_products: "Aucun produit trouvé",
    productName: "Nom du produit",
    stock: "Stock",
    production: "Production",
    quantity: "Quantité",
    price: "Prix",
    status: "Statut",
    inDevelopment: "En développement",
    // Product status
    lowStockStatus: "Stock faible",
    available: "Disponible",
    // Product report modal
    productsReport: "Rapport des produits",
    from: "Du",
    to: "Au",
    exportExcel: "Exporter Excel",
    exportPDF: "Exporter PDF",
    report: "Rapport",
    // Product form
    addProduct: "Ajouter un produit",
    generalInfo: "Informations générales",
    productType: "Type de produit",
    finalProduct: "Produit Final",
    rawMaterial: "Matière Première",
    productNameLabel: "Nom du produit",
    category: "Catégorie",
    unit: "Unité de mesure",
    description: "Description",
    pricing: "Tarification",
    purchasePrice: "Prix d'achat",
    salePrice: "Prix de vente",
    minStock: "Stock minimum",
    availableStock: "Stock disponible",
    barcode: "Code-barres",
    // Parametre/settings
    cooperativeInfo: "Informations de la Coopérative",
    cooperativeName: "Nom de la Coopérative",
    location: "Adresse",
    phoneNumber: "Numéro de téléphone",
    email: "Email",
    getLocation: "Obtenir la localisation",
    loading: "Chargement...",
    saveCoop: "Enregistrer la coopérative",
    saveProfile: "Enregistrer le profil",
    plan: "Plan",
    freePlan: "Essai gratuit",
    // Parametre/settings (additional)
    logo: "Logo",
    remove: "Retirer",
    saveChanges: "Enregistrer les modifications",
    generalSettings: "Paramètres généraux",
    defaultLanguage: "Langue par défaut",
    arabic: "Arabe",
    french: "Français",
    currency: "Devise",
    moroccanDirham: "Dirham marocain",
    euro: "Euro",
    timezone: "Fuseau horaire",
    lockedOnFreePlan: "Réservé aux plans payants",
    lowStockAlerts: "Alertes de stock faible",
    lowStockNotification: "Recevoir une notification lorsque le stock d'un produit est faible.",
    newOrderNotifications: "Notifications de nouvelle commande",
    newOrderNotification: "Recevoir une notification lorsqu'une nouvelle commande est passée.",
    weeklyReports: "Rapports hebdomadaires",
    weeklyReportNotification: "Recevoir un rapport hebdomadaire par email.",
    // User Profile translations
    userProfile: "Profil utilisateur",
    personalInformation: "Informations personnelles",
    username: "Nom d'utilisateur",
    emailAddress: "Adresse e-mail",
    firstName: "Prénom",
    lastName: "Nom de famille",
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    edit: "Modifier",
    cancel: "Annuler",
    saveChanges: "Enregistrer les modifications",
    passwordChangedSuccess: "Mot de passe modifié avec succès",
    passwordChangeError: "Erreur lors du changement de mot de passe",
    profileSavedSuccess: "Profil enregistré avec succès",
    profileSaveError: "Erreur lors de l'enregistrement du profil",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    // Plan Badge translations
    currentPlan: "Plan actuel",
    planActive: "Actif",
    planExpires: "Expire le",
    premiumPlan: "Premium",
    proPlan: "Professionnel",
    basicPlan: "Basique",
    trialPlan: "Essai gratuit",
    security: "Sécurité",
    change: "Changer",
    twoFactorAuth: "Authentification à deux facteurs",
    extraProtection: "Protection supplémentaire du compte.",
    activeSessions: "Sessions actives",
    manageDevices: "Gérer les appareils connectés.",
    view: "Voir",
    backupExport: "Sauvegarde et Export",
    autoBackup: "Sauvegarde automatique",
    dailyBackup: "Sauvegarde quotidienne des données.",
    exportData: "Exporter les données",
    downloadCopy: "Télécharger une copie de vos données.",
    importData: "Importer des données",
    importFromFile: "Importer à partir d'un fichier.",
    import: "Importer",
    dangerZone: "Zone dangereuse",
    deleteAllData: "Supprimer toutes les données",
    permanentDelete: "Suppression permanente de toutes les données.",
    casablanca: "Casablanca",
    english: "Anglais",
    locationIcon: "📍",
    netProfit: "Bénéfice net",
    overallProfit: "Bénéfice global",
    debtTracker: "Suivi des dettes",
    clientDebts: "Clients débiteurs",
    supplierDebts: "Fournisseurs créditeurs",
    salesTrends: "Tendances des ventes",
    dailyTrend: "Ventes quotidiennes",
    monthlyTrend: "Ventes mensuelles",
    thisMonth: "Ce mois-ci",
    lastMonth: "Le mois dernier",
    unpaidClients: "Clients non payés",
    unpaidSuppliers: "Fournisseurs non payés",
    totalAmount: "Montant total",
    daysOverdue: "jours de retard",
    viewDetails: "Voir les détails",
    payNow: "Payer maintenant",
    sendReminder: "Envoyer un rappel",
    lastWeek: "La semaine dernière",
    thisWeek: "Cette semaine",
    growth: "croissance",
    decline: "baisse",
    stable: "stable",
    bestDay: "Meilleur jour",
    worstDay: "Pire jour",
    bestMonth: "Meilleur mois",
    worstMonth: "Pire mois",
    viewAll: "Voir tout",
    netProfitInfo: "Bénéfice net = Total des ventes payées - Achats - Dépenses",
    overallProfitInfo: "Bénéfice global = Total des ventes payées - Achats",
    clientDebtsInfo: "Somme des montants restants dus par les clients non payés.",
    supplierDebtsInfo: "Somme des montants restants dus aux fournisseurs non payés.",
    dailyTrendInfo: "Total des ventes quotidiennes de cette semaine avec le meilleur et le pire jour.",
    monthlyTrendInfo: "Total des ventes mensuelles de ce mois avec le meilleur et le pire mois.",
    // POS System Translations
    pos: {
      title: "Point de Vente",
      home: "Accueil",
      sales: "Ventes",
      reports: "Rapports",
      receipts: "Reçus",
      payments: "Paiements",
      session: {
        session: "Session",
        started: "Session POS démarrée",
        startError: "Échec du démarrage de la session POS",
        duration: "Durée",
        active: "Session Active",
        noActive: "Aucune Session Active",
        starting: "Démarrage de la Session...",
        endSession: "Terminer la Session"
      },
      cart: {
        title: "Panier",
        items: "articles",
        itemAdded: "Article ajouté au panier",
        itemRemoved: "Article retiré du panier",
        cleared: "Panier vidé",
        empty: "Votre panier est vide",
        addProducts: "Ajoutez des produits pour commencer",
        subtotal: "Sous-total",
        discount: "Remise",
        tax: "Taxe",
        total: "Total",
        checkout: "Finaliser",
        clearCart: "Vider le panier",
        removeItem: "Retirer l'article",
        insufficientStock: "Stock insuffisant (demandé: {{requested}}, disponible: {{available}})",
        lowStock: "Stock faible ({{count}} restant)",
        noDiscount: "Aucune remise",
        percentageDiscount: "Remise en pourcentage",
        fixedDiscount: "Remise fixe",
        resetDiscount: "Réinitialiser la remise",
        customerDiscount: "Remise client"
      },
      products: {
        title: "Gérer les produits",
        loading: "Chargement des produits...",
        loadError: "Échec du chargement des produits",
        retry: "Réessayer",
        searchPlaceholder: "Rechercher des produits par nom, code-barres...",
        allCategories: "Toutes les catégories",
        sortByName: "Trier par nom",
        sortByPriceAsc: "Prix: Croissant",
        sortByPriceDesc: "Prix: Décroissant",
        sortByStock: "Trier par stock",
        gridView: "Vue grille",
        listView: "Vue liste",
        noProducts: "Aucun produit trouvé",
        clearSearch: "Effacer la recherche",
        showingResults: "Affichage de {{count}} sur {{total}} produits",
        outOfStock: "Rupture de stock",
        lowStock: "Stock faible",
        inStock: "En stock"
      },
      customer: {
        title: "Client",
        management: "Gestion des clients",
        searchPlaceholder: "Rechercher des clients par nom, téléphone...",
        select: "Sélectionner",
        noResults: "Aucun client trouvé",
        createNew: "Créer un nouveau client",
        addNew: "Ajouter un nouveau client",
        clearSearch: "Effacer la recherche",
        clear: "Effacer le client",
        name: "Nom",
        phone: "Téléphone",
        email: "Email",
        address: "Adresse",
        cancel: "Annuler",
        create: "Créer",
        createError: "Échec de la création du client",
        totalPurchases: "Total des achats",
        lastPurchase: "Dernier achat",
        never: "Jamais"
      },
      payment: {
        title: "Paiement",
        orderSummary: "Résumé de la commande",
        paymentMethods: "Méthodes de paiement",
        total: "Total",
        orderTotal: "Total de la commande",
        totalPaid: "Total payé",
        remaining: "Restant",
        change: "Monnaie",
        notes: "Notes",
        notesPlaceholder: "Ajouter des notes de paiement...",
        cash: "Espèces",
        card: "Carte",
        digital: "Numérique",
        check: "Chèque",
        full: "Complet",
        complete: "Finaliser le paiement",
        cancel: "Annuler",
        processing: "Traitement",
        processingError: "Échec du traitement du paiement",
        insufficientAmount: "Montant de paiement insuffisant"
      },
      receipt: {
        complete: "Transaction terminée",
        preview: "Aperçu du reçu",
        download: "Télécharger",
        print: "Imprimer",
        close: "Fermer"
      },
      checkout: {
        emptyCart: "Le panier est vide"
      },
      backToProducts: "Retour aux Produits",
      backToHome: "← Retour à l'accueil",
      backToSales: "← Retour aux ventes",
      back: "← Retour",
      user: {
        unknown: "Inconnu",
        cashier: "Caissier"
      },
      system: {
        online: "En ligne",
        offline: "Hors ligne",
        currentTime: "Heure actuelle"
      },
      labels: {
        items: "Articles",
        payment: "Paiement" 
      },
      // Product Pricing Modal
      pricing: {
        title: "Définir le prix et la quantité",
        close: "×",
        basePrice: "Prix de base",
        stock: "Stock",
        pricePerUnit: "Prix par unité",
        local: "Local (-20%)",
        standard: "Standard",
        tourist: "Touriste (+50%)",
        quantity: "Quantité",
        tax: "Taxe",
        taxRate: "Taux de taxe",
        taxAmount: "Montant de la taxe",
        subtotal: "Sous-total",
        total: "Total",
        cancel: "Annuler",
        addToCart: "Ajouter au panier",
        selectTax: "Sélectionner une taxe",
        addTax: "Ajouter une nouvelle taxe",
        taxHistory: "Historique des taxes"
      },
      stockStatus: {
        inStock: "Disponible",   // French default
        lowStock: "Faible",      // French default
        outOfStock: "Rupture"    // French default
      },
      paymentManagement:{
        title: "Gestion des paiements",
        refresh: "Actualiser",
        loadingPayment:"Chargement des données de paiement...",
        period: "Période:",
        today: "Aujourd'hui",
        week: "Cette semaine",
        month: "Ce mois",
        title: "Gestion des Paiements",
        paymentSummary: "Résumé des Paiements",
        totalSales: "Ventes Totales",
        numberOfTransactions: "Nombre de Transactions",
        averageTransaction: "Transaction Moyenne",
        paymentMethods: "Méthodes de Paiement",
        transactions: "Transactions:",
        average: "Moyenne:",
        percentage: "Pourcentage:"
      },
      adminDashboard: {
        title: "Tableau de bord Admin",
        backToPOS: "← Retour au POS",
        systemManagement: "Gestion du système",
        connectedAs: "Connecté:",
        loading: "Chargement des données...",
        retry: "Réessayer",
        tabs: {
          overview: "Aperçu",
          products: "Produits",
          sales: "Ventes",
          customers: "Clients",
          receipts: "Reçus",
          payments: "Paiements",
          settings: "Paramètres"
        },
        overview: {
          todaySales: "Ventes d'aujourd'hui",
          revenue: "Chiffre d'affaires",
          averageSale: "Vente moyenne",
          paymentMethods: "Méthodes de paiement"
        },
        products: {
          title: "Gestion des produits",
          addProduct: "+ Ajouter un produit",
          availableProducts: "Produits disponibles",
          description: "Pour gérer les produits, utilisez le tableau de bord principal.",
          manageInventory: "Gérer l'inventaire",
          viewStocks: "Voir les stocks"
        },
        sales: {
          title: "Historique des ventes",
          detailedReport: "Rapport détaillé",
          recentSales: "Ventes récentes",
          description: "Pour voir l'historique complet des ventes, utilisez le tableau de bord principal.",
          viewAllSales: "Voir toutes les ventes",
          advancedAnalytics: "Analytics avancées"
        },
        customers: {
          title: "Gestion des clients",
          newCustomer: "+ Nouveau client",
          registeredCustomers: "Clients enregistrés",
          description: "Pour gérer les clients, utilisez le tableau de bord principal.",
          viewAllCustomers: "◉ Voir tous les clients",
          addCustomer: "+ Ajouter un client"
        },
        receipts: {
          title: "Gestion des reçus",
          viewAllReceipts: "▦ Voir tous les reçus",
          salesReceipts: "Reçus de vente",
          description: "Tous les reçus sont automatiquement générés lors des ventes POS.",
          receiptHistory: "📄 Historique des reçus",
          printPage: "🖨️ Imprimer cette page"
        },
        payments: {
          title: "Gestion des paiements",
          paymentReport: "Rapport de paiements",
          paymentMethods: "Méthodes de paiement",
          description: "Surveillez les méthodes de paiement utilisées dans votre POS.",
          viewPaymentAnalytics: "📊 Analytics de paiement",
          paymentHistory: "📋 Historique des paiements",
          paymentSummary: "Résumé des paiements (30 derniers jours)"
        },
        settings: {
          title: "Paramètres du système",
          systemStatus: "Statut du système",
          erpStatus: "Statut ERP :",
          erpConnected: "🟢 Connecté",
          lastSync: "Dernière sync :",
          posStatus: "Statut POS :",
          posOnline: "🟢 En ligne",
          quickActions: "Actions rapides",
          syncERP: "Sync ERP",
          exportInventory: "Export inventaire",
          generateReport: "Générer rapport",
          backup: "Sauvegarde",
          systemInfo: "Informations système",
          version: "Version :",
          database: "Base de données :",
          dbConnected: "🟢 Connectée",
          sessionTime: "Temps de session :",
          security: "Sécurité",
          manageUsers: "Gérer utilisateurs",
          manageRoles: "Gérer rôles",
          confirmDelete: "Êtes-vous sûr de vouloir supprimer cette taxe ?",
          editTax: "Modifier la taxe",
          addTax: "Ajouter une taxe",
          taxNamePlaceholder: "Ex: Taxe VIP",
          taxType: "Type de taxe",
          customTax: "Taxe personnalisée",
          setAsDefault: "Définir comme taxe par défaut",
          update: "Mettre à jour",
          create: "Créer",
          posSettings: "Paramètres POS",
          taxSettings: "Gestion des taxes",
          defaultTaxRate: "Taux de taxe par défaut :",
          localTax: "Taxe locale (-20%)",
          standardTax: "Taxe standard",
          touristTax: "Taxe touristique (+50%)",
          customTaxes: "Taxes personnalisées",
          addCustomTax: "Ajouter une taxe personnalisée",
          taxName: "Nom de la taxe",
          taxRate: "Taux (%)",
          actions: "Actions",
          edit: "Modifier",
          delete: "Supprimer",
          save: "Sauvegarder",
          cancel: "Annuler",
          pricingSettings: "Paramètres de tarification",
          defaultPricing: "Tarification par défaut",
          localPricing: "Prix local (-20%)",
          standardPricing: "Prix standard",
          touristPricing: "Prix touristique (+50%)",
          receiptSettings: "Paramètres de reçu",
          receiptHeader: "En-tête du reçu",
          receiptFooter: "Pied de page du reçu",
          showTax: "Afficher la taxe",
          showChange: "Afficher la monnaie rendue",
          currency: "Devise",
          language: "Langue",
          dateFormat: "Format de date"
        }
      },
      // Product Management
      productManagement: {
        title: "Gérer les produits",
        searchPlaceholder: "Rechercher des produits par nom ou code-barres...",
        all: "Tous",
        available: "Disponible",
        stock: "Stock",
        edit: "Modifier",
        delete: "Supprimer"
      },
      // Receipt History
      receiptHistory: {
        title: "Historique des reçus",
        backToHome: "← Retour à l'accueil",
        period: "Période:",
        today: "Aujourd'hui",
        refresh: "🔄 Actualiser",
        receiptNumber: "Reçu #",
        date: "Date",
        client: "Client",
        cashier: "Caissier",
        items: "Articles",
        total: "Total",
        actions: "Actions",
        print: "🖨️ Imprimer",
        view: "Voir"
      },
      // Admin/System
      admin: {
        title: "Administration",
        systemSettings: "Paramètres système",
        logoutEndSession: "Déconnexion et fin de session",
        systemOnline: "Système en ligne",
        sessionActive: "Session active"
      }
    }
  },
  ar: {
    // Notifications
    welcome_title: "مرحباً",
    config_title: "الإعدادات",
    config_description: "قم بتكوين إعداداتك للحصول على تجربة مثالية.",
    whatsapp_title: "انضم إلى مجتمعنا",
    whatsapp_description: "انضم إلى مجموعة واتساب الخاصة بنا للتواصل مع المستخدمين الآخرين والحصول على المساعدة.",
    join_button: "انضم",
    welcome_description: "نحن سعداء بترحيبك في نظام إدارة الموارد الخاص بك.",
    // Common UI
    dashboard: "لوحة التحكم",
    overview: "نظرة عامة",
    products: "المنتجات",
    ventes: "المبيعات",
    sales: "المبيعات",
    achats: "المشتريات",
    clients: "العملاء",
    fournisseurs: "الموردون",
    depenses: "المصروفات",
    members: "الأعضاء",
    add_member: "إضافة عضو",
    edit_member: "تعديل العضو",
    member_details: "تفاصيل العضو",
    preview: "معاينة",
    name: "الاسم",
    role: "الدور",
    phone: "الهاتف",
    salary: "الراتب",
    cin: "رقم الهوية",
    close: "إغلاق",
    search_member_placeholder: "البحث بالاسم أو الدور أو الهاتف...",
    loading: "جاري التحميل...",
    export_members_title: "تصدير الأعضاء",
    export_excel: "تصدير إكسل",
    export_pdf: "تصدير PDF",
    confirm_delete: "تأكيد الحذف",
    delete_member_confirm: "هل أنت متأكد من حذف العضو",
    delete_warning: "لا يمكن التراجع عن هذا الإجراء.",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    notifications: "الإشعارات",
    add: "إضافة",
    addNewProduct: "إضافة منتج جديد",
    edit: "تعديل",
    delete: "حذف",
    search: "بحث...",
    export: "تصدير",
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    yes: "نعم",
    no: "لا",
    actions: "إجراءات",
    no_products: "لا توجد منتجات",
    productName: "اسم المنتج",
    stock: "المخزون",
    production: "الإنتاج",
    quantity: "الكمية",
    price: "السعر",
    status: "الحالة",
    inDevelopment: "قيد التطوير",
    // Product status
    lowStockStatus: "مخزون منخفض",
    available: "متوفر",
    // Product report modal
    productsReport: "تقرير المنتجات",
    from: "من",
    to: "إلى",
    exportExcel: "تصدير إكسل",
    exportPDF: "تصدير PDF",
    report: "التقرير",
    // Product form
    addProduct: "إضافة منتج",
    generalInfo: "معلومات عامة",
    productType: "نوع المنتج",
    finalProduct: "منتج نهائي",
    rawMaterial: "مادة خام",
    productNameLabel: "اسم المنتج",
    category: "الفئة",
    unit: "وحدة القياس",
    description: "الوصف",
    pricing: "التسعير",
    purchasePrice: "سعر الشراء",
    salePrice: "سعر البيع",
    minStock: "الحد الأدنى للمخزون",
    availableStock: "المخزون المتوفر",
    barcode: "الباركود",
    // Parametre/settings
    cooperativeInfo: "معلومات التعاونية",
    cooperativeName: "اسم التعاونية",
    location: "العنوان",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    getLocation: "الحصول على الموقع",
    loading: "جاري التحميل...",
    saveCoop: "حفظ معلومات التعاونية",
    saveProfile: "حفظ الملف الشخصي",
    plan: "الخطة",
    freePlan: "تجربة مجانية",
    // Parametre/settings (additional)
    logo: "الشعار",
    remove: "إزالة",
    saveChanges: "حفظ التغييرات",
    generalSettings: "الإعدادات العامة",
    defaultLanguage: "اللغة الافتراضية",
    arabic: "العربية",
    french: "الفرنسية",
    currency: "العملة",
    moroccanDirham: "درهم مغربي",
    euro: "يورو",
    timezone: "المنطقة الزمنية",
    lockedOnFreePlan: "مخصص للخطط المدفوعة",
    lowStockAlerts: "تنبيهات انخفاض المخزون",
    lowStockNotification: "تلقي إشعار عندما يكون مخزون منتج منخفضًا.",
    newOrderNotifications: "إشعارات الطلبات الجديدة",
    newOrderAlert: "تلقي إشعار عند تقديم طلب جديد.",
    weeklyReports: "تقارير أسبوعية",
    weeklyEmailReports: "تلقي تقرير أسبوعي عبر البريد الإلكتروني.",
    security: "الأمان",
    changePassword: "تغيير كلمة المرور",
    updatePassword: "تحديث كلمة مرور الحساب.",
    change: "تغيير",
    twoFactorAuth: "المصادقة الثنائية",
    extraProtection: "حماية إضافية للحساب.",
    activeSessions: "الجلسات النشطة",
    manageDevices: "إدارة الأجهزة المتصلة.",
    view: "عرض",
    backupExport: "النسخ الاحتياطي والتصدير",
    autoBackup: "نسخ احتياطي تلقائي",
    dailyBackup: "نسخ احتياطي يومي للبيانات.",
    exportData: "تصدير البيانات",
    downloadCopy: "تنزيل نسخة من بياناتك.",
    importData: "استيراد البيانات",
    importFromFile: "استيراد من ملف.",
    import: "استيراد",
    dangerZone: "منطقة الخطر",
    deleteAllData: "حذف جميع البيانات",
    permanentDelete: "حذف دائم لجميع البيانات.",
    casablanca: "الدار البيضاء",
    english: "الإنجليزية",
    locationIcon: "📍",
    netProfit: "صافي الربح",
    overallProfit: "الربح الإجمالي",
    debtTracker: "متابعة الديون",
    clientDebts: "ديون العملاء",
    supplierDebts: "ديون الموردين",
    salesTrends: "اتجاهات المبيعات",
    dailyTrend: "المبيعات اليومية",
    monthlyTrend: "المبيعات الشهرية",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    unpaidClients: "عملاء غير مدفوعين",
    unpaidSuppliers: "موردون غير مدفوعين",
    totalAmount: "المبلغ الإجمالي",
    daysOverdue: "أيام متأخرة",
    viewDetails: "عرض التفاصيل",
    payNow: "ادفع الآن",
    sendReminder: "إرسال تذكير",
    lastWeek: "الأسبوع الماضي",
    thisWeek: "هذا الأسبوع",
    growth: "نمو",
    decline: "انخفاض",
    stable: "مستقر",
    bestDay: "أفضل يوم",
    worstDay: "أسوأ يوم",
    bestMonth: "أفضل شهر",
    worstMonth: "أسوأ شهر",
    viewAll: "عرض الكل",
    netProfitInfo: "صافي الربح = مجموع المبيعات المدفوعة - المشتريات - المصاريف",
    overallProfitInfo: "الربح الإجمالي = مجموع المبيعات المدفوعة - المشتريات",
    clientDebtsInfo: "مجموع المبالغ المتبقية على العملاء غير المدفوعين.",
    supplierDebtsInfo: "مجموع المبالغ المتبقية للموردين غير المدفوعين.",
    dailyTrendInfo: "إجمالي المبيعات اليومية لهذا الأسبوع مع أفضل وأسوأ يوم.",
    monthlyTrendInfo: "إجمالي المبيعات الشهرية لهذا الشهر مع أفضل وأسوأ شهر.",
    // POS System Translations
    pos: {
      title: "نقطة البيع",
      topProducts: "المنتجات الأكثر مبيعًا",
      home: "الرئيسية",
      sold: "مبيعات",
      sales: "المبيعات",
      reports: "التقارير",
      receipts: "الإيصالات",
      payments: "المدفوعات",
      session: {
        session: "الجلسة",
        started: "تم بدء جلسة نقطة البيع",
        startError: "فشل في بدء جلسة نقطة البيع",
        duration: "المدة",
        active: "جلسة نشطة",
        noActive: "لا توجد جلسة نشطة",
        starting: "بدء الجلسة...",
        endSession: "إنهاء الجلسة"
      },
      cart: {
        inCart: "في السلة",  // Arabic translation
        title: "السلة",
        items: "عناصر",
        itemAdded: "تم إضافة العنصر إلى السلة",
        itemRemoved: "تم إزالة العنصر من السلة",
        cleared: "تم إفراغ السلة",
        empty: "سلتك فارغة",
        addProducts: "أضف منتجات للبدء",
        subtotal: "المجموع الفرعي",
        discount: "الخصم",
        tax: "الضريبة",
        total: "المجموع",
        checkout: "الدفع",
        clearCart: "إفراغ السلة",
        removeItem: "إزالة العنصر",
        insufficientStock: "مخزون غير كافٍ (مطلوب: {{requested}}، متوفر: {{available}})",
        lowStock: "مخزون منخفض ({{count}} متبقي)",
        noDiscount: "لا يوجد خصم",
        percentageDiscount: "خصم بنسبة مئوية",
        fixedDiscount: "خصم ثابت",
        resetDiscount: "إعادة تعيين الخصم",
        customerDiscount: "خصم العميل"
      },
      stockStatus: {
        inStock: "متوفر",       // Arabic
        lowStock: "قليل",       // Arabic
        outOfStock: "نفذ"       // Arabic
      },
      labels: {
        stock: "المخزون:",
        items: "العناصر",
        payment: "الدفع",
        change: "الباقي", 
      },
      products: {
        title: "إدارة المنتجات",
        loading: "جاري تحميل المنتجات...",
        loadError: "فشل في تحميل المنتجات",
        retry: "إعادة المحاولة",
        searchPlaceholder: "البحث عن المنتجات بالاسم، الباركود...",
        allCategories: "جميع الفئات",
        sortByName: "ترتيب حسب الاسم",
        sortByPriceAsc: "السعر: من الأقل للأعلى",
        sortByPriceDesc: "السعر: من الأعلى للأقل",
        sortByStock: "ترتيب حسب المخزون",
        gridView: "عرض الشبكة",
        listView: "عرض القائمة",
        noProducts: "لم يتم العثور على منتجات",
        clearSearch: "مسح البحث",
        showingResults: "عرض {{count}} من {{total}} منتج",
        outOfStock: "نفد المخزون",
        lowStock: "مخزون منخفض",
        inStock: "متوفر في المخزون"
      },
      customer: {
        title: "العميل",
        management: "إدارة العملاء",
        searchPlaceholder: "البحث عن العملاء بالاسم، الهاتف...",
        select: "اختيار",
        noResults: "لم يتم العثور على عملاء",
        createNew: "إنشاء عميل جديد",
        addNew: "إضافة عميل جديد",
        clearSearch: "مسح البحث",
        clear: "مسح العميل",
        name: "الاسم",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        address: "العنوان",
        cancel: "إلغاء",
        create: "إنشاء",
        createError: "فشل في إنشاء العميل",
        totalPurchases: "إجمالي المشتريات",
        lastPurchase: "آخر عملية شراء",
        never: "أبداً"
      },
      payment: {
        title: "الدفع",
        orderSummary: "ملخص الطلب",
        paymentMethods: "طرق الدفع",
        total: "المجموع",
        orderTotal: "إجمالي الطلب",
        totalPaid: "إجمالي المدفوع",
        remaining: "المتبقي",
        change: "الباقي",
        notes: "ملاحظات",
        notesPlaceholder: "إضافة ملاحظات الدفع...",
        cash: "نقداً",
        card: "بطاقة",
        digital: "رقمي",
        check: "شيك",
        full: "كامل",
        complete: "إتمام الدفع",
        cancel: "إلغاء",
        processing: "جاري المعالجة",
        processingError: "فشل في معالجة الدفع",
        insufficientAmount: "مبلغ الدفع غير كافٍ"
      },
      receipt: {
        complete: "تمت المعاملة",
        preview: "معاينة الإيصال",
        download: "تحميل",
        print: "طباعة",
        close: "إغلاق"
      },
      checkout: {
        emptyCart: "السلة فارغة"
      },
      backToProducts: "العودة إلى المنتجات",
      backToHome: "← العودة إلى الرئيسية",
      backToSales: "← العودة إلى المبيعات",
      back: "← رجوع",
      user: {
        unknown: "غير معروف",
        cashier: "أمين الصندوق"
      },
      system: {
        online: "متصل",
        offline: "غير متصل",
        currentTime: "الوقت الحالي"
      },
      paymentManagement:{
        title: "إدارة المدفوعات",
        refresh: "تحديث",
        loadingPayment:"جاري تحميل بيانات الدفع...",
        period: "الفترة:",
        today: "اليوم",
        week: "هذا الأسبوع",
        month: "هذا الشهر",
        title: "إدارة المدفوعات",
        paymentSummary: "ملخص المدفوعات",
        totalSales: "إجمالي المبيعات",
        numberOfTransactions: "عدد المعاملات",
        averageTransaction: "متوسط المعاملة",
        paymentMethods: "طرق الدفع",
        transactions: "المعاملات:",
        average: "المتوسط:",
        percentage: "النسبة المئوية:"
      },
      adminDashboard: {
        title: "لوحة تحكم الإدارة",
        backToPOS: "← العودة إلى نقطة البيع",
        systemManagement: "إدارة النظام",
        connectedAs: "متصل كـ :",
        loading: "جاري تحميل البيانات...",
        retry: "إعادة المحاولة",
        tabs: {
          overview: "نظرة عامة",
          products: "المنتجات",
          sales: "المبيعات",
          customers: "العملاء",
          receipts: "الإيصالات",
          payments: "المدفوعات",
          settings: "الإعدادات"
        },
        overview: {
          todaySales: "مبيعات اليوم",
          revenue: "الإيرادات",
          averageSale: "متوسط البيع",
          paymentMethods: "طرق الدفع"
        },
        products: {
          title: "إدارة المنتجات",
          addProduct: "+ إضافة منتج",
          availableProducts: "المنتجات المتاحة",
          description: "لإدارة المنتجات، استخدم لوحة التحكم الرئيسية.",
          manageInventory: "إدارة المخزون",
          viewStocks: "عرض المخزون"
        },
        sales: {
          title: "تاريخ المبيعات",
          detailedReport: "تقرير مفصل",
          recentSales: "المبيعات الأخيرة",
          description: "لمشاهدة التاريخ الكامل للمبيعات، استخدم لوحة التحكم الرئيسية.",
          viewAllSales: "عرض جميع المبيعات",
          advancedAnalytics: "تحليلات متقدمة"
        },
        customers: {
          title: "إدارة العملاء",
          newCustomer: "+ عميل جديد",
          registeredCustomers: "العملاء المسجلون",
          description: "لإدارة العملاء، استخدم لوحة التحكم الرئيسية.",
          viewAllCustomers: "◉ عرض جميع العملاء",
          addCustomer: "+ إضافة عميل"
        },
        receipts: {
          title: "إدارة الإيصالات",
          viewAllReceipts: "▦ عرض جميع الإيصالات",
          salesReceipts: "إيصالات المبيعات",
          description: "جميع الإيصالات يتم إنشاؤها تلقائياً عند المبيعات في نقطة البيع.",
          receiptHistory: "📄 تاريخ الإيصالات",
          printPage: "🖨️ طباعة هذه الصفحة"
        },
        payments: {
          title: "إدارة المدفوعات",
          paymentReport: "تقرير المدفوعات",
          paymentMethods: "طرق الدفع",
          description: "راقب طرق الدفع المستخدمة في نقطة البيع الخاصة بك.",
          viewPaymentAnalytics: "📊 تحليلات الدفع",
          paymentHistory: "📋 تاريخ المدفوعات",
          paymentSummary: "ملخص المدفوعات (آخر 30 يوم)"
        },
        settings: {
          title: "إعدادات النظام",
          systemStatus: "حالة النظام",
          erpStatus: "حالة ERP :",
          erpConnected: "🟢 متصل",
          lastSync: "آخر مزامنة :",
          posStatus: "حالة نقطة البيع :",
          posOnline: "🟢 متصل",
          quickActions: "إجراءات سريعة",
          syncERP: "مزامنة ERP",
          exportInventory: "تصدير المخزون",
          generateReport: "إنشاء تقرير",
          backup: "نسخ احتياطي",
          systemInfo: "معلومات النظام",
          version: "الإصدار :",
          database: "قاعدة البيانات :",
          dbConnected: "🟢 متصلة",
          sessionTime: "وقت الجلسة :",
          security: "الأمان",
          manageUsers: "إدارة المستخدمين",
          manageRoles: "إدارة الأدوار",
          confirmDelete: "هل أنت متأكد من أنك تريد حذف هذه الضريبة؟",
          editTax: "تعديل الضريبة",
          addTax: "إضافة ضريبة",
          taxNamePlaceholder: "مثال: ضريبة VIP",
          taxType: "نوع الضريبة",
          customTax: "ضريبة مخصصة",
          setAsDefault: "تعيين كضريبة افتراضية",
          update: "تحديث",
          create: "إنشاء",
          posSettings: "إعدادات نقطة البيع",
          taxSettings: "إدارة الضرائب",
          defaultTaxRate: "معدل الضريبة الافتراضي :",
          localTax: "ضريبة محلية (-20%)",
          standardTax: "ضريبة عادية",
          touristTax: "ضريبة سياحية (+50%)",
          customTaxes: "ضرائب مخصصة",
          addCustomTax: "إضافة ضريبة مخصصة",
          taxName: "اسم الضريبة",
          taxRate: "المعدل (%)",
          actions: "الإجراءات",
          edit: "تعديل",
          delete: "حذف",
          save: "حفظ",
          cancel: "إلغاء",
          pricingSettings: "إعدادات التسعير",
          defaultPricing: "التسعير الافتراضي",
          localPricing: "سعر محلي (-20%)",
          standardPricing: "سعر عادي",
          touristPricing: "سعر سياحي (+50%)",
          receiptSettings: "إعدادات الإيصال",
          receiptHeader: "رأس الإيصال",
          receiptFooter: "ذيل الإيصال",
          showTax: "إظهار الضريبة",
          showChange: "إظهار الباقي",
          currency: "العملة",
          language: "اللغة",
          dateFormat: "تنسيق التاريخ"
        }
      },
      // Product Pricing Modal
      pricing: {
        title: "تحديد السعر والكمية",
        close: "×",
        basePrice: "السعر الأساسي",
        stock: "المخزون",
        pricePerUnit: "السعر لكل وحدة",
        local: "محلي (-20%)",
        standard: "عادي",
        tourist: "سياحي (+50%)",
        quantity: "الكمية",
        tax: "الضريبة",
        taxRate: "معدل الضريبة",
        taxAmount: "مبلغ الضريبة",
        subtotal: "المجموع الفرعي",
        total: "المجموع الإجمالي",
        cancel: "إلغاء",
        addToCart: "إضافة إلى السلة",
        selectTax: "اختر الضريبة",
        addTax: "إضافة ضريبة جديدة",
        taxHistory: "تاريخ الضرائب"
      },
      // Product cards
      productcards:{
        inCart: "في السلة"
      },
      // Product Management
      productManagement: {
        title: "إدارة المنتجات",
        searchPlaceholder: "البحث عن المنتجات بالاسم أو الباركود...",
        all: "الكل",
        available: "متوفر",
        stock: "المخزون",
        edit: "تعديل",
        delete: "حذف"
      },
      // Receipt History
      receiptHistory: {
        title: "تاريخ الإيصالات",
        backToHome: "← العودة إلى الرئيسية",
        period: "الفترة:",
        today: "اليوم",
        refresh: "🔄 تحديث",
        receiptNumber: "رقم الإيصال",
        date: "التاريخ",
        client: "العميل",
        cashier: "أمين الصندوق",
        items: "العناصر",
        total: "المجموع",
        actions: "الإجراءات",
        print: "🖨️ طباعة",
        view: "عرض"
      },
      // Admin/System
      admin: {
        title: "الإدارة",
        systemSettings: "إعدادات النظام",
        logoutEndSession: "تسجيل الخروج وإنهاء الجلسة",
        systemOnline: "النظام متصل",
        sessionActive: "جلسة نشطة"
      }
    }
  },
  en: {
    // Notifications
    welcome_title: "Welcome",
    config_title: "Configuration",
    config_description: "Set up your preferences for the best experience.",
    whatsapp_title: "Join our community",
    whatsapp_description: "Join our WhatsApp group to connect with other users and get help.",
    join_button: "Join",
    welcome_description: "We are excited to welcome you to your ERP.",
    // Common UI
    dashboard: "Dashboard",
    overview: "Overview",
    products: "Products",
    ventes: "Sales",
    sales: "Sales",
    achats: "Purchases",
    clients: "Clients",
    fournisseurs: "Suppliers",
    depenses: "Expenses",
    members: "Members",
    add_member: "Add Member",
    edit_member: "Edit Member",
    member_details: "Member Details",
    preview: "Preview",
    name: "Name",
    role: "Role",
    phone: "Phone",
    salary: "Salary",
    cin: "ID Number",
    close: "Close",
    search_member_placeholder: "Search by name, role, or phone...",
    loading: "Loading...",
    export_members_title: "Export Members",
    export_excel: "Export Excel",
    export_pdf: "Export PDF",
    confirm_delete: "Confirm Deletion",
    delete_member_confirm: "Are you sure you want to delete the member",
    delete_warning: "This action cannot be undone.",
    settings: "Settings",
    logout: "Logout",
    notifications: "Notifications",
    add: "Add",
    addNewProduct: "Add New Product",
    edit: "Edit",
    delete: "Delete",
    search: "Search...",
    export: "Export",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    actions: "Actions",
    no_products: "No products found",
    productName: "Product Name",
    stock: "Stock",
    quantity: "Quantity",
    price: "Price",
    status: "Status",
    inDevelopment: "In development",
    // Product status
    lowStockStatus: "Low stock",
    available: "Available",
    // Product report modal
    productsReport: "Products Report",
    from: "From",
    to: "To",
    exportExcel: "Export Excel",
    exportPDF: "Export PDF",
    report: "Report",
    // Product form
    addProduct: "Add Product",
    generalInfo: "General Information",
    productType: "Product Type",
    finalProduct: "Final Product",
    rawMaterial: "Raw Material",
    productNameLabel: "Product Name",
    category: "Category",
    unit: "Unit",
    description: "Description",
    pricing: "Pricing",
    purchasePrice: "Purchase Price",
    salePrice: "Sale Price",
    minStock: "Minimum Stock",
    availableStock: "Available Stock",
    barcode: "Barcode",
    // Parametre/settings
    cooperativeInfo: "Cooperative Information",
    cooperativeName: "Cooperative Name",
    location: "Address",
    phoneNumber: "Phone Number",
    email: "Email",
    getLocation: "Get Location",
    loading: "Loading...",
    saveCoop: "Save Cooperative",
    saveProfile: "Save Profile",
    plan: "Plan",
    freePlan: "Free Trial",
    // Parametre/settings (additional)
    logo: "Logo",
    remove: "Remove",
    saveChanges: "Save Changes",
    generalSettings: "General Settings",
    defaultLanguage: "Default Language",
    arabic: "Arabic",
    french: "French",
    currency: "Currency",
    moroccanDirham: "Moroccan Dirham",
    euro: "Euro",
    timezone: "Timezone",
    lockedOnFreePlan: "Reserved for paid plans",
    lowStockAlerts: "Low Stock Alerts",
    lowStockNotification: "Receive a notification when a product's stock is low.",
    newOrderNotifications: "New Order Notifications",
    newOrderNotification: "Receive a notification when a new order is placed.",
    weeklyReports: "Weekly Reports",
    weeklyReportNotification: "Receive a weekly report by email.",
    // User Profile translations
    userProfile: "User Profile",
    personalInformation: "Personal Information",
    username: "Username",
    emailAddress: "Email Address",
    firstName: "First Name",
    lastName: "Last Name",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    edit: "Edit",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    passwordChangedSuccess: "Password changed successfully",
    passwordChangeError: "Error changing password",
    profileSavedSuccess: "Profile saved successfully",
    profileSaveError: "Error saving profile",
    showPassword: "Show Password",
    hidePassword: "Hide Password",
    // Plan Badge translations
    currentPlan: "Current Plan",
    planActive: "Active",
    planExpires: "Expires on",
    premiumPlan: "Premium",
    proPlan: "Professional",
    basicPlan: "Basic",
    trialPlan: "Trial",
    security: "Security",
    change: "Change",
    twoFactorAuth: "Two-Factor Authentication",
    extraProtection: "Extra account protection.",
    activeSessions: "Active Sessions",
    manageDevices: "Manage connected devices.",
    view: "View",
    backupExport: "Backup & Export",
    autoBackup: "Automatic Backup",
    dailyBackup: "Daily data backup.",
    exportData: "Export Data",
    downloadCopy: "Download a copy of your data.",
    importData: "Import Data",
    importFromFile: "Import from file.",
    import: "Import",
    dangerZone: "Danger Zone",
    deleteAllData: "Delete All Data",
    permanentDelete: "Permanent deletion of all data.",
    casablanca: "Casablanca",
    english: "English",
    locationIcon: "📍",
    netProfit: "Net Profit",
    overallProfit: "Overall Profit",
    debtTracker: "Debt Tracker",
    clientDebts: "Client Debts",
    supplierDebts: "Supplier Debts",
    salesTrends: "Sales Trends",
    dailyTrend: "Daily Sales",
    monthlyTrend: "Monthly Sales",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    unpaidClients: "Unpaid Clients",
    unpaidSuppliers: "Unpaid Suppliers",
    totalAmount: "Total Amount",
    daysOverdue: "days overdue",
    viewDetails: "View Details",
    payNow: "Pay Now",
    sendReminder: "Send Reminder",
    lastWeek: "Last Week",
    thisWeek: "This Week",
    growth: "growth",
    decline: "decline",
    stable: "stable",
    bestDay: "Best day",
    worstDay: "Worst day",
    bestMonth: "Best month",
    worstMonth: "Worst month",
    viewAll: "View all",
    netProfitInfo: "Net Profit = Total Paid Sales - Purchases - Expenses",
    overallProfitInfo: "Gross Profit = Total Paid Sales - Purchases",
    clientDebtsInfo: "Sum of remaining amounts owed by unpaid clients.",
    supplierDebtsInfo: "Sum of remaining amounts owed to unpaid suppliers.",
    dailyTrendInfo: "Total daily sales for this week with best and worst day.",
    monthlyTrendInfo: "Total monthly sales for this month with best and worst month.",
    
    // POS System Translations
    pos: {
      title: "Point of Sale",
      session: {
        session: "Session",
        started: "POS session started",
        startError: "Failed to start POS session",
        duration: "Duration"
      },
      cart: {
        title: "Cart",
        items: "items",
        itemAdded: "Item added to cart",
        itemRemoved: "Item removed from cart",
        cleared: "Cart cleared",
        empty: "Your cart is empty",
        addProducts: "Add products to start",
        subtotal: "Subtotal",
        discount: "Discount",
        tax: "Tax",
        total: "Total",
        checkout: "Checkout",
        clearCart: "Clear cart",
        removeItem: "Remove item",
        insufficientStock: "Insufficient stock (requested: {{requested}}, available: {{available}})",
        lowStock: "Low stock ({{count}} remaining)",
        noDiscount: "No discount",
        percentageDiscount: "Percentage discount",
        fixedDiscount: "Fixed discount",
        resetDiscount: "Reset discount",
        customerDiscount: "Customer discount"
      },
      products: {
        loading: "Loading products...",
        loadError: "Failed to load products",
        retry: "Retry",
        searchPlaceholder: "Search products by name, barcode...",
        allCategories: "All categories",
        sortByName: "Sort by name",
        sortByPriceAsc: "Price: Low to High",
        sortByPriceDesc: "Price: High to Low",
        sortByStock: "Sort by stock",
        gridView: "Grid view",
        listView: "List view",
        noProducts: "No products found",
        clearSearch: "Clear search",
        showingResults: "Showing {{count}} of {{total}} products",
        outOfStock: "Out of stock",
        lowStock: "Low stock",
        inStock: "In stock"
      },
      customer: {
        title: "Customer",
        management: "Customer Management",
        searchPlaceholder: "Search customers by name, phone...",
        select: "Select",
        noResults: "No customers found",
        createNew: "Create new customer",
        addNew: "Add new customer",
        clearSearch: "Clear search",
        clear: "Clear customer",
        name: "Name",
        phone: "Phone",
        email: "Email",
        address: "Address",
        cancel: "Cancel",
        create: "Create",
        createError: "Failed to create customer",
        totalPurchases: "Total purchases",
        lastPurchase: "Last purchase",
        never: "Never"
      },
      payment: {
        title: "Payment",
        orderSummary: "Order Summary",
        paymentMethods: "Payment Methods",
        total: "Total",
        orderTotal: "Order Total",
        totalPaid: "Total Paid",
        remaining: "Remaining",
        change: "Change",
        notes: "Notes",
        notesPlaceholder: "Add payment notes...",
        cash: "Cash",
        card: "Card",
        digital: "Digital",
        check: "Check",
        full: "Full",
        complete: "Complete Payment",
        cancel: "Cancel",
        processing: "Processing",
        processingError: "Payment processing failed",
        insufficientAmount: "Insufficient payment amount"
      },
      receipt: {
        complete: "Transaction Complete"
      },
      checkout: {
        emptyCart: "Cart is empty"
      },
      backToProducts: "Back to Products",
      backToHome: "← Back to Home",
      backToSales: "← Back to Sales",
      back: "← Back",
      user: {
        unknown: "Unknown",
        cashier: "Cashier"
      },
      system: {
        online: "Online",
        offline: "Offline",
        currentTime: "Current Time"
      },
      paymentManagement:{
        refresh: "Refresh",
        loadingPayment:"Loading payment data...",
        period: "Period:",
        today: "Today",
        week: "This week",
        month: "This month",
        title: "Payment Management",
        paymentSummary: "Payment Summary",
        totalSales: "Total Sales",
        numberOfTransactions: "Number of Transactions",
        averageTransaction: "Average Transaction",
        paymentMethods: "Payment Methods",
        transactions: "Transactions:",
        average: "Average:",
        percentage: "Percentage:"
      },
      adminDashboard: {
        title: "Admin Dashboard",
        backToPOS: "← Back to POS",
        systemManagement: "System Management",
        connectedAs: "Connected as:",
        loading: "Loading data...",
        retry: "Retry",
        tabs: {
          overview: "Overview",
          products: "Products",
          sales: "Sales",
          customers: "Customers",
          receipts: "Receipts",
          payments: "Payments",
          settings: "Settings"
        },
        overview: {
          todaySales: "Today's Sales",
          revenue: "Revenue",
          averageSale: "Average Sale",
          paymentMethods: "Payment Methods"
        },
        products: {
          title: "Product Management",
          addProduct: "+ Add Product",
          availableProducts: "Available Products",
          description: "To manage products, use the main dashboard.",
          manageInventory: "Manage Inventory",
          viewStocks: "View Stocks"
        },
        sales: {
          title: "Sales History",
          detailedReport: "Detailed Report",
          recentSales: "Recent Sales",
          description: "To view complete sales history, use the main dashboard.",
          viewAllSales: "View All Sales",
          advancedAnalytics: "Advanced Analytics"
        },
        customers: {
          title: "Customer Management",
          newCustomer: "+ New Customer",
          registeredCustomers: "Registered Customers",
          description: "To manage customers, use the main dashboard.",
          viewAllCustomers: "◉ View All Customers",
          addCustomer: "+ Add Customer"
        },
        receipts: {
          title: "Receipt Management",
          viewAllReceipts: "▦ View All Receipts",
          salesReceipts: "Sales Receipts",
          description: "All receipts are automatically generated during POS sales.",
          receiptHistory: "📄 Receipt History",
          printPage: "🖨️ Print This Page"
        },
        payments: {
          title: "Payment Management",
          paymentReport: "Payment Report",
          paymentMethods: "Payment Methods",
          description: "Monitor payment methods used in your POS.",
          viewPaymentAnalytics: "📊 Payment Analytics",
          paymentHistory: "📋 Payment History",
          paymentSummary: "Payment Summary (Last 30 days)"
        },
        settings: {
          title: "System Settings",
          systemStatus: "System Status",
          erpStatus: "ERP Status:",
          erpConnected: "🟢 Connected",
          lastSync: "Last sync:",
          posStatus: "POS Status:",
          posOnline: "🟢 Online",
          quickActions: "Quick Actions",
          syncERP: "Sync ERP",
          exportInventory: "Export Inventory",
          generateReport: "Generate Report",
          backup: "Backup",
          systemInfo: "System Information",
          version: "Version:",
          database: "Database:",
          dbConnected: "🟢 Connected",
          sessionTime: "Session Time:",
          security: "Security",
          manageUsers: "Manage Users",
          manageRoles: "Manage Roles",
          confirmDelete: "Are you sure you want to delete this tax?",
          editTax: "Edit Tax",
          addTax: "Add Tax",
          taxNamePlaceholder: "Ex: VIP Tax",
          taxType: "Tax Type",
          customTax: "Custom Tax",
          setAsDefault: "Set as Default Tax",
          update: "Update",
          create: "Create",
          posSettings: "POS Settings",
          taxSettings: "Tax Management",
          defaultTaxRate: "Default Tax Rate:",
          localTax: "Local Tax (-20%)",
          standardTax: "Standard Tax",
          touristTax: "Tourist Tax (+50%)",
          customTaxes: "Custom Taxes",
          addCustomTax: "Add Custom Tax",
          taxName: "Tax Name",
          taxRate: "Rate (%)",
          actions: "Actions",
          edit: "Edit",
          delete: "Delete",
          save: "Save",
          cancel: "Cancel",
          pricingSettings: "Pricing Settings",
          defaultPricing: "Default Pricing",
          localPricing: "Local Price (-20%)",
          standardPricing: "Standard Price",
          touristPricing: "Tourist Price (+50%)",
          receiptSettings: "Receipt Settings",
          receiptHeader: "Receipt Header",
          receiptFooter: "Receipt Footer",
          showTax: "Show Tax",
          showChange: "Show Change",
          currency: "Currency",
          language: "Language",
          dateFormat: "Date Format"
        }
      },
      // Product Pricing Modal
      pricing: {
        title: "Set Price & Quantity",
        close: "×",
        basePrice: "Base Price",
        stock: "Stock",
        pricePerUnit: "Price per unit",
        local: "Local (-20%)",
        standard: "Standard",
        tourist: "Tourist (+50%)",
        quantity: "Quantity",
        tax: "Tax",
        taxRate: "Tax Rate",
        taxAmount: "Tax Amount",
        subtotal: "Subtotal",
        total: "Total",
        cancel: "Cancel",
        addToCart: "Add to Cart",
        selectTax: "Select Tax",
        addTax: "Add New Tax",
        taxHistory: "Tax History"
      },
      // Product Management
      productManagement: {
        title: "Manage Products",
        searchPlaceholder: "Search products by name or barcode...",
        all: "All",
        available: "Available",
        stock: "Stock",
        edit: "Edit",
        delete: "Delete"
      },
      // Receipt History
      receiptHistory: {
        title: "Receipt History",
        backToHome: "← Back to Home",
        period: "Period:",
        today: "Today",
        refresh: "🔄 Refresh",
        receiptNumber: "Receipt #",
        date: "Date",
        client: "Client",
        cashier: "Cashier",
        items: "Items",
        total: "Total",
        actions: "Actions",
        print: "🖨️ Print",
        view: "View"
      },
      // Admin/System
      admin: {
        title: "Admin",
        systemSettings: "Paramètres système",
        logoutEndSession: "Déconnexion et fin de session",
        systemOnline: "Système en ligne",
        sessionActive: "Session active"
      }
    }
  },
};

export default translations; 